// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"248":"c4ae25a6","550":"d2ec2f81","787":"cd7c5d16","929":"d2ec2f81","960":"35aec028"}[chunkId] + ".css";
};